import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SoftwareConsulting from '../Tech/SoftwareConsulting/SoftwareConsulting';
import Solutions from '../Solutions/Solutions';
import Redes from '../Tech/Networks/Redes';
import CCTV from '../Tech/CCTV/CCTV';
import Marketing from '../Marketing/Marketing';
import OtrosServicios from '../OtrosServicios/OtrosServicios';
import Equipos from '../Equipos/Equipos';
import About from '../About/About';
import Contact from '../Contact/Contact';

const Content = () => {
  return (
    <main className="flex-grow">
      <Routes>
        {/* Inicio (overview) */}
        <Route path="/" element={<Solutions />} />

        {/* Tecnología */}
        <Route path="/tecnologia/redes" element={<Redes />} />
        <Route path="/tecnologia/cctv" element={<CCTV />} />
        <Route path="/tecnologia/software" element={<SoftwareConsulting />} />

        {/* Marketing */}
        <Route path="/marketing" element={<Marketing />} />

        {/* Otros servicios (energía) */}
        <Route path="/otros-servicios" element={<OtrosServicios />} />

        {/* Venta de equipos (a futuro: Tienda) */}
        <Route path="/equipos" element={<Equipos />} />

        {/* Institucional */}
        <Route path="/about-us" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* Redirecciones de rutas antiguas */}
        <Route path="/solutions" element={<Navigate to="/" replace />} />
        <Route path="/prueba" element={<Navigate to="/" replace />} />
        <Route path="/tech" element={<Navigate to="/tecnologia/redes" replace />} />
        <Route path="/tech/network-infrastructure" element={<Navigate to="/tecnologia/redes" replace />} />
        <Route path="/tech/software-consulting" element={<Navigate to="/tecnologia/software" replace />} />

        {/* Cualquier otra ruta */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
  );
};

export default Content;
